module.exports = __webpack_public_path__ + "img/UI_loading_H5BG_01_ebbc60498.jpg";